<template>
  <div class="base-wrap bg-white mt-5 pb-3 mb-5" style="box-shadow: 0 0 5px 3px #ddd;" id="shop_cart">
    <!--团队票-->
    <div  v-if="ticketType === 1">
      <!--步骤条-->
      <el-steps  :active='activeIndex1' finish-status="success" align-center class="pt-5 pb-5">
        <el-step title = '提交订单' />
        <el-step title = '等待确认' />
        <el-step title = '等待支付' />
        <el-step title = '订单完成' />
      </el-steps>
      <!--主体内容-->
      <!-- <scenic-group-ticket/> -->
    </div>
    <!--散客票/度假产品-->
   <div v-if="ticketType === 2 || productId">
     <!--步骤条-->
     <el-steps  :active='activeIndex' finish-status="success" align-center class="pt-5 pb-5" >
       <el-step title = '提交订单'/>
       <el-step title = '订单支付'/>
       <el-step title = '等待出票'/>
       <el-step title = '出票成功'/>
     </el-steps>
     <!--主体内容-->
   </div>
   <scenic-group-ticket v-if="show == 'group'" @active="activeChange" />
   <scenic-individual-ticket v-else :initChosen="initChosen" :tickets="availableTickets" />
  </div>
</template>

<script>
  import {mapActions,mapState} from 'vuex'
  import ScenicGroupTicket from './ScenicGroupTicket'
  import ScenicIndividualTicket from './ScenicIndividualTicket'

  export default {
    name: 'ScenicShopCart',
    components:{ScenicGroupTicket,ScenicIndividualTicket},
    data() {
      return {
         activeIndex: 0,                                   //默认显示步骤条
         activeIndex1: 1
      }
    },
    watch:{
      status (newval) {
        if (newval == 14) this.activeIndex1 = 2
        if (newval == 8) this.activeIndex1 = 3
        if (newval == 9) this.activeIndex1 = 4
      }
    },
    computed: {
      ...mapState(['ScenicTicketsOpt','OrderDetail']),
      ticketType() { return Number(this.$route.query.ticketType) },
      storeId() { return this.$route.query.store },
      ticketId() { return this.$route.query.ticket },
      productId() { return this.$route.query.productId },
      show () { return this.$route.query.show },
      status () { return this.OrderDetail.status },
      initChosen() { return (this.ScenicTicketsOpt.filter(item => item.id == this.ticketId))[0] },
      availableTickets() { return this.ScenicTicketsOpt.filter(item => item.ticket_type === this.initChosen.ticket_type) },
    },
    created() {
      //获取门票信息/度假产品信息 排除团队票回返详情的情况
      if (!this.show) {
        if (!this.productId) this.ScenicTickets({ 
          viewpoint_id: this.storeId,
          ticket: this.ticketId,
          ticket_type: this.ticketType
        })
        else this.GetDisplayInfo({
          type: '7',
          data: { id: this.productId, },
          successFun:(e) => {}
        })
      }
    },
    methods:{
      ...mapActions(['ScenicTickets','GetDisplayInfo']),
      activeChange (index) { this.activeIndex1 = index }
    }
  }
</script>
